import React from 'react';

import { I18n } from 'aws-amplify';

const Steps = (props) => {

    if (!props.bp || !props.bp.client) return null;

    const item = props.bp.client;

    function getClassName(step) {



        if (item.status === step) {
            return 'is-active';
        }
        else if (item.status >= step) {
            return 'is-completed bp-is-completed';
        }
        else {
            return 'bp-is-pending';
        }
    }

    const items = [
        {
            index: 1,
            title: I18n.get("Incompleto"),
            desc: 'Iniciou o cadastro.'
        },
        {
            index: 7,
            title: I18n.get("Aprovado"),
            desc: 'Concede acesso ao admin.'
        }
    ];


    return (
        <div className="steps">
            {items.map((step, index) =>
                (<div key={index} className={'step-item ' + getClassName(step.index)}>
                    <div className="step-marker"></div>
                    <div className="step-details">
                        <p className="step-title">{step.title}</p>
                        <p>{step.desc}</p>
                    </div>
                </div>)
            )}
        </div>
    )
};

export default Steps;
